import { ITeamsRecord, ITeamsStatusInfo, TeamsActions } from "./types";

export type TeamsAction =
    | { type: TeamsActions.GET_TEAMS_CONTACTS; payload: ITeamsRecord[] }
    | { type: TeamsActions.TEAMS_CONTACTS_LOADING; payload: boolean }
    | { type: TeamsActions.GET_TEAMS_STATUSES; payload: ITeamsStatusInfo }
    | {
          type: TeamsActions.TEAMS_ERROR;
          payload: string;
      }
    | {
          type: TeamsActions.TEAMS_STATUSES_LOADING;
          payload: boolean;
      };

export const getTeamsContactsLoading = (payload: boolean): TeamsAction => {
    return { type: TeamsActions.TEAMS_CONTACTS_LOADING, payload };
};

export const setTeamsStatusesLoading = (payload: boolean): TeamsAction => {
    return { type: TeamsActions.TEAMS_STATUSES_LOADING, payload };
};

export const setTeamsStatuses = (payload: ITeamsStatusInfo): TeamsAction => {
    return { type: TeamsActions.GET_TEAMS_STATUSES, payload };
};

export const setTeamsError = (payload: string): TeamsAction => {
    return { type: TeamsActions.TEAMS_ERROR, payload };
};
